export const DETAILS_INTERACTION = 'detailsLibInteraction';